import styled, { css } from 'styled-components';

import { BaseButton } from '@r1-frontend/ui-react/components/buttons/baseButton';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const TariffElement = styled.div`
    flex-direction: column;
    justify-content: center;
    row-gap: 8px;
    width: 100%;
    min-height: 76px;
    padding: 4px 12px 4px 8px;
    border-radius: ${BorderRadius.InnerBlockRadius};
    background-color: ${COLORS.BgSurface};

    @media (max-width: ${wideBreakpoints.mobile}) {
        justify-content: flex-start;
        padding: 8px 12px 12px 8px;
    }
`;

export const RowWrap = styled.div`
    flex-wrap: nowrap;
    column-gap: 24px;
    align-items: center;
    width: 100%;
`;

export const DescriptionWrap = styled.div`
    flex: 1 0 1%;
    flex-wrap: nowrap;
    align-items: center;
    column-gap: 12px;
`;

export const MobileOnlyWrap = styled(RowWrap)`
    display: none;

    @media (max-width: ${wideBreakpoints.mobile}) {
        display: flex;
        justify-content: space-between;
        padding: 0 0 0 4px;
    }
`;

export const DesktopOnlyWrap = styled.div<{ withCounts?: boolean }>`
    display: flex;
    align-items: center;
    column-gap: 24px;

    @media (min-width: ${wideBreakpoints.mobile}) {
        ${({ withCounts }) => withCounts
            ? css`
                width: 240px;
                flex-wrap: nowrap;
                column-gap: initial;
                justify-content: space-between;
            `
            : ''
        }
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        display: none;
    }
`;

export const TitleWrap = styled.div`
    flex: 1 0 1%;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    flex-wrap: nowrap;
    row-gap: 4px;
`;

export const Title = styled.div`
    width: 100%;
    ${FONTS.MediumS};
    color: ${COLORS.TextPrimary};
`;

export const Description = styled.div`
    ${FONTS.XS};
    color: ${COLORS.TextSecondary};
`;

export const Button = styled(BaseButton)`
    svg {
        fill: ${COLORS.Control};
        stroke: ${COLORS.Control};
    }
`;
